import type { RequestBookingOutcome, RequestOutcome } from "@albertine/types";

export const RequestOutcomeMap: Record<RequestOutcome, string> = {
    notBooked: "Not converted to Booking",
    booked: "Booked",
    noBookingNeeded: "Information request only",
    memberCancelled: "Member cancelled",
    noActionNeeded: "No further action",
};

export const RequestBookingOutcomeMap: Record<RequestBookingOutcome, string> = {
    firstChoiceBooked: "First choice booked",
    alternativeChoiceBooked: "Alternative accepted",
};
